var React = require('react');

function HomepageQuotePath (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"homepage-quote","fill":"none","stroke":"rgb(250,250,240)","strokeLinecap":"butt","strokeLinejoin":"miter","strokeWidth":"2","d":"M4.7046301 627.81240039s574 101.5 715.5-183-210-467.29479607-393-436.79479607-243 321.5 69 406 1044-235.70520393 1044-235.70520393"}));
}

HomepageQuotePath.defaultProps = {"viewBox":"0 0 1444.909 650.117"};

module.exports = HomepageQuotePath;

HomepageQuotePath.default = HomepageQuotePath;
